import React from "react";
import { MARQUEE_ITEMS } from "../../mock";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center font-heading uppercase text-[#0a1020] text-lg sm:text-xl tracking-tight whitespace-nowrap">
        <span className="px-6">{item}</span>
        <span className="text-[#0a1020]/60 text-xs">◆</span>
      </span>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <div className="relative overflow-hidden bg-[#6b9be8] py-4 border-y border-[#22304e]" data-testid="marquee">
      <div className="flex animate-marquee w-max">
        <Row />
        <Row />
        <Row />
      </div>
    </div>
  );
};

export default Marquee;
